import { createContext, PropsWithChildren } from 'react';

import { rootStore } from 'stores/root/RootStore';
import { RootStoreT } from 'types/frontend/RootStore';

export const RootContext = createContext<RootStoreT>(
  {} as RootStoreT, // 물음표를 없애기 위해
);

type RootProviderTypes = PropsWithChildren<{}>;

export const RootProvider = ({ children }: RootProviderTypes): JSX.Element => {
  return (
    <RootContext.Provider value={rootStore}>{children}</RootContext.Provider>
  );
};
